// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'animate.css';

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' //(根据版本路径不同会有差异，按照自己版本路径)
Vue.use(ElementUI)


import Swiper from 'swiper';
import 'swiper/css/swiper.min.css'  // 根据实际路径和文件修改
Vue.prototype.Swiper = Swiper;


// import jquery from "jquery";
// Vue.prototype.$ = jquery;


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js